import React from 'react';
import './style.scss';
import { isRTL } from '../../../services/userModel.js';
import classNames from 'classnames';
import { getTranslateTitle } from '../../../utils/objects-util.js';
import EditableTable from '../EditableTable/EditableTable.jsx';
import { connect } from 'react-redux';
import preloader from "../../../assets/images/preloader.GIF";
import { CONTROL_TYPE } from '../../../utils/enums.js';
import { getOrderSource } from '../../../utils/order.js';

// Price override differs from SKU override in one structural way: every order
// source gets a PAIR of columns — the price value and a visible switch. The
// backend treats them as one unit (a price override always carries visibility),
// so both cells mark dirty independently but are saved together.
const SectionItemPriceOverride = ({ t, item, column, onPropChange, isLoading, translationsLanguage }) => {
  const providers = item?.providers || [];
  // name + read-only original price + (price, visible) pair per source
  const columnsCount = 2 + providers.length * 2;
  const columnsWidth = 100 / columnsCount;

  const newColumns = column.columns.map(c => ({...c, width: `${columnsWidth}%`, fixedWidth: `${columnsWidth}%`})).concat([
    {
      title: 'settings.price_override.ORIGINAL_VALUES_LABEL',
      accessor: 'originalPrice',
      width: `${columnsWidth}%`,
      fixedWidth: `${columnsWidth}%`,
      type: CONTROL_TYPE.text,
    },
  ]).concat(providers.flatMap(source => ([
    {
      title: source ? getOrderSource(source) : 'settings.price_override.NEW_PRICE',
      accessor: `price-${source}`,
      width: `${columnsWidth}%`,
      fixedWidth: `${columnsWidth}%`,
      markWhenDirty: true,
      // Inherited rows keep the input empty; the base price shows as a placeholder,
      // so "no override" and "override equal to base" are visually distinct.
      placeholder: item => item.overridePrice === null ? `${item.originalPrice}` : '',
      type: CONTROL_TYPE.inputNumber,
    },
    {
      title: 'settings.price_override.VISIBLE_LABEL',
      accessor: `visible-${source}`,
      width: `${columnsWidth}%`,
      fixedWidth: `${columnsWidth}%`,
      markWhenDirty: true,
      centered: true,
      type: CONTROL_TYPE.switch,
    },
  ]))).filter(Boolean);

  return (
    <div className={classNames('sectionItemPriceOverride', { rtl: isRTL() })}>
      <table className={classNames('header')}>
        <tbody>
          <tr>
            {newColumns?.map((column, index) => {
              return (
                <td
                  key={`headerItem-${column.title}-${index}`}
                  className={classNames('headerItem', {
                    centered: column.centered,
                  })}
                  style={{
                    width: column.width ? `${column.width}` : `auto`,
                    textAlign: column.textRight ? 'right' : '',
                  }}
                >
                  {getTranslateTitle(column.title)}
                  &nbsp;
                </td>
              );
            })}
          </tr>
        </tbody>
      </table>
      {isLoading && (
        <div className={classNames('loaderWrapper')}>
          <img className='preloader' src={preloader} alt='preloader' />
        </div>
      )}
      <EditableTable virtualized model={{...column, columns: newColumns}} items={item?.values} isTranslationRtl={translationsLanguage === "he" || translationsLanguage === "ar"} isLoading={false} onPropChange={onPropChange} />
    </div>
  );
};

const mapStateToProps = state => {
  return {
    isLoading: state.sectionsWrapperData.isLoading,
      translationsLanguage: state.restaurant?.data?.translations?.language
  };
};

export default connect(mapStateToProps)(SectionItemPriceOverride);
